import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../../Util/requests"
import Questionnaire from "../../../Components/Questionnaire"
import ProductPack from "../"
import image_add from "../../../Images/Buttons/add.png"
import image_delete from "../../../Images/Buttons/cancel.png"
import image_loading from "../../../Images/spinner.gif";
import image_select from "../../../Images/Buttons/select_circle.png"

const SearchProductPack = ({databaseType, databasePath, jsonProduct, jsonCompany, jsonLogin, system, showMenu, width}) => {
  const [code, setCode] = useState(0)
  const [update, setUpdate] = useState(0)
  const [showChange, setShowChange] = useState(false)

  const [jsonProductPack, setJsonProductPack] = useState("")
    
  const [result, setResult] = useState({})
  const [loading, setLoading] = useState("")
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")

  const [askQuestionnaire, setAskQuestionnaire] = useState("")
  const [showQuestionnaire, setShowQuestionnaire] = useState(false)

  useEffect(() => {
    let returnJson = []

    setLoading("Aguarde buscando as informações...")
    setWarning("")
    setError("")

    const jProductPack = "{ \"PRODUCT_O\": { \"ID\": " + jsonProduct.ID + " } }"     

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jProductPack)
    formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "PRODUCT_PACK/Search", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
    ", \"ERROR\": \"Não foi possível pesquisar as embalagens do produto. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        return
      }

      setResult(returnJson)
      setLoading("")
    })
  }, [databaseType, databasePath, jsonProduct, jsonLogin, system, update])

  const add = () => {
    setJsonProductPack(JSON.parse("{ \"PRODUCT_O\": { \"ID\": " + jsonProduct.ID + " } }"))
    setWarning("")
    setError("")
    setShowChange(true)
  }

  const back = () => {
    setWarning("")
    setError("")
    setShowChange(false)
  }

  const callDelete = (item) => {
    console.log(item)

    setCode(item.ID)
    setAskQuestionnaire("Deseja realmente excluir a embalagem do produto (" + item.PRODUCT_D.DESCRIPTION + ") ?")
    setShowQuestionnaire(true)
  }

  const cancelDelete = () => {
    setShowQuestionnaire(false)
    setCode(0)
  }

  const confirmDelete = () => {
    let returnJson = []
    const jProductPack = "{ \"ID\": "+ code +" }"

    setLoading("Aguarde excluindo a embalagem do produto...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jProductPack)
    formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "PRODUCT_PACK/Delete", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
    ", \"ERROR\": \"Não foi possível excluir a embalagem do produto. ("+ response +")\" }") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setShowQuestionnaire(false)
        setCode(0)
        setLoading("")

        return
      }

      returnJson.WARNING && setWarning(returnJson.WARNING)

      setShowQuestionnaire(false)
      setCode(0)
      setLoading("")

      const count = update + 1
      setUpdate(count)
    })
  }

  const save = (productPack) => {
    let returnJson = []
    const json = JSON.parse(productPack)

    if (json.ID === undefined)
    {
      setLoading("Aguarde incluindo a embalagem do produto...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", productPack)
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("SYSTEM", system)
      formData.append("GET_ID", true)

      axios.post(BASE_URL + "PRODUCT_PACK/Insert", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível incluir a embalagem do produto. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Inclusão efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Inclusão efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
    else
    {
      setLoading("Aguarde alterando a embalagem do produto...")
      setWarning("")
      setError("")

      const formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_OLD", JSON.stringify(jsonProductPack))
      formData.append("JSON_NEW_1", productPack)
      formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.put(BASE_URL + "PRODUCT_PACK/Update", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível alterar a embalagem do produto. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }

        returnJson.WARNING ? setWarning("Alteração efetuada com sucesso! ("+ returnJson.WARNING +")")
        : setWarning("Alteração efetuada com sucesso!")

        setLoading("")
        setError("")
        setShowChange(false)

        const count = update + 1
        setUpdate(count)
      })
    }
  }

  const setSelected = (productPack) => {
    setJsonProductPack(productPack)
    setWarning("")
    setError("")
    setShowChange(true)
  }

  return(
    <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginBottom: 10}
      : {display: "flex", flexDirection: "column", flexGrow: 0, paddingLeft: 10, paddingRight: 10, marginBottom: 10}}>

      { loading ?
          <div style={{display: "flex", flexDirection: "column", flexGrow: 0, justifyContent: "center", alignItems: "center", marginTop: 10,
            marginBottom: 10}}>
            <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
          </div>
        :
        <>
          { warning && 
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
            </div> 
          }

          { error &&
            <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10}}>
              <label style={{fontWeight: 600, color: "red"}}>{error}</label>
            </div>
          }

          { showChange ?
              <ProductPack
                databaseType={databaseType}
                databasePath={databasePath}
                jsonProductPack={jsonProductPack}
                jsonCompany={jsonCompany}
                jsonLogin={jsonLogin}
                system={system}
                save={save}
                back={back} 
                showMenu={showMenu}
                width={width} />
            :
              <>
                { showQuestionnaire ?
                    <div style={{marginTop: 10}}>
                      <Questionnaire
                        ask={askQuestionnaire}
                        setConfirm={() => confirmDelete()}
                        setCancel={() => cancelDelete()} />
                    </div>
                  :
                    <>
                      <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
                        <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 5,
                          marginLeft: 5, width: 147}} onClick={() => add()}>
                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5,
                            paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                            <img style={{height: 32, width: 32}} src={image_add} alt="Novo"/>
                          </div>
                          <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                            <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Novo</label>
                          </div>
                        </div>
                      </div>

                      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
                      </div>

                      <div style={(width < 450) ? {paddingLeft: 5, paddingRight: 5}
                        : {paddingLeft: 10, paddingRight: 10}}>

                        { result.OBJECT ?
                          <>
                            <div style={showMenu ?
                                (width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}
                                : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}
                                : (width < 880) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}
                                : {display: "flex", flexDirection: "row", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}
                              :
                                (width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}
                                :
                                  {display: "flex", flexDirection: "row", flexGrow: 1,
                                  borderBottomColor: "black", borderBottomWidth: 2, borderBottomStyle: "solid", 
                                  marginTop: 10, marginBottom: 4}}>

                                <div style={(showMenu) ?
                                    (width < 970) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1}
                                  : 
                                    (width < 690) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                  <div style={showMenu ?
                                      (width < 970) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 80, maxWidth: 80}
                                    :  
                                      (width < 690) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 80, maxWidth: 80}}>

                                    <label style={{fontWeight: 600}}>Código</label>
                                  </div>

                                  <div style={(showMenu) ?
                                      (width < 690) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15, minWidth: 180}
                                      : (width < 970) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15, minWidth: 180}
                                      : {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 10, minWidth: 180}
                                    : 
                                      (width < 690) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15, minWidth: 180}
                                      : {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 10, minWidth: 180}}>

                                    <label style={{fontWeight: 600}}>Produto</label>
                                  </div>
                                </div>

                                <div>
                                  { showMenu ?
                                      (width < 590) ? <></>
                                      : (width < 690) ? 
                                        <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 100, maxWidth: 100}}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32,
                                            maxWidth: 32}} />

                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32, 
                                            maxWidth: 32}}/>
                                        </div>
                                      : (width < 880) ? <></>
                                      :
                                        <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 100, maxWidth: 100}}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32,
                                            maxWidth: 32}} />

                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32, 
                                            maxWidth: 32}}/>
                                        </div>
                                    :
                                      (width < 590) ? <></>
                                      :
                                        <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 100, maxWidth: 100}}>
                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32,
                                            maxWidth: 32}} />

                                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minHeight: 32, minWidth: 32, 
                                            maxWidth: 32}}/>
                                        </div>
                                  }

                                </div>
                            </div>

                            <div style={showMenu ? {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}
                              : (width < 330) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, minWidth: 32, maxWidth: 32}
                                : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}} />

                              { result.OBJECT.map(item => (
                                <div key={item.ID} style={showMenu ?
                                    (width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}

                                    : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}

                                    : (width < 880) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}

                                    : {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}
                                  :
                                    (width < 590) ?
                                      {display: "flex", flexDirection: "column", flexGrow: 1,
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}
                                    : 
                                    {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                      backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5, paddingRight: 8,
                                      borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8,
                                      marginTop: 4, minWidth: 180}}>

                                  <div style={(showMenu) ?
                                      (width < 970) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1}
                                    : 
                                      (width < 690) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                                    <div style={showMenu ?
                                        (width < 970) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 15, minWidth: 80, maxWidth: 80}
                                      :  
                                        (width < 690) ? {display: "flex", flexGrow: 1, marginLeft: 15, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 80, maxWidth: 80}}>
                                      <label>{item.PRODUCT_D.ID}</label>
                                    </div>

                                    <div style={(showMenu) ?
                                        (width < 690) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15, minWidth: 180}
                                        : (width < 970) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15, minWidth: 180}
                                        : {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 10, minWidth: 180}
                                      : 
                                        (width < 690) ? {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 15}
                                        : {display: "flex", flexGrow: 1, wordBreak: "break-all", marginLeft: 10, minWidth: 180}}>

                                      <label>{item.PRODUCT_D.DESCRIPTION}</label>
                                    </div>
                                  </div>

                                  <div style={showMenu ?
                                      (width < 590) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, justifyContent: "center"}
                                      : (width < 690) ? {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 90, maxWidth: 90}
                                      : (width < 880) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, justifyContent: "center"}
                                      : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 90, maxWidth: 90}
                                    :
                                      (width < 590) ? {display: "flex", flexGrow: 0, alignItems: "center", marginTop: 10, justifyContent: "center"}
                                      : {display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 90, maxWidth: 90}}>

                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                      <img
                                        style={{height: 32, width: 32}}
                                        src={image_select}
                                        name="searchProductPackSelected"
                                        alt="Selecionar"
                                        onClick={(() => setSelected(item))} />
                                    </div>

                                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", marginLeft: 10, minWidth: 32, maxWidth: 32}}>
                                      <img
                                        style={{height: 28, width: 28}}
                                        src={image_delete}
                                        name="searchProductPackDeleted"
                                        alt="Deletar"
                                        onClick={() => callDelete(item)} />
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </>
                        :
                          <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", marginTop: 10,
                            marginBottom: 10}}>
                            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>Nenhum registro encontrado.</label>
                          </div>
                      }
                      </div>
                    </>
                }
              </>
          }
        </>
      }
    </div>
  )
}

export default SearchProductPack